import { queryClient } from '@/lib/query/query-client';
import { realtimeManager } from '@/lib/realtime/realtime-manager';
import { sameOriginPath } from '@/lib/utils/safe-url';
import { sessionScope } from './session-scope';
import { useAuthStore } from '@/store/auth-store';
import { isPublicViewer } from '@/features/locale/session';

/** A new document drops mounted selections, stores and connections of the old account. */
export function openSession(destination: string | null | undefined = '/') {
  void queryClient.cancelQueries();
  queryClient.clear();
  realtimeManager.disconnect();
  window.location.replace(sameOriginPath(destination) || '/');
}

/** Other tabs share persisted credentials and must also leave the old account. */
export function syncSessionAcrossTabs() {
  const listener = (event: StorageEvent) => {
    if (event.key !== 'blaze-auth') return;
    try {
      const next = event.newValue ? JSON.parse(event.newValue).state : { token: null };
      const changed = sessionScope(next) !== sessionScope(useAuthStore.getState());
      // Rehydrate synchronously from localStorage before old responses can finish.
      if (event.newValue === null) useAuthStore.getState().clearAuth();
      else void useAuthStore.persist.rehydrate();
      if (changed && !isPublicViewer()) openSession(next.token ? '/' : '/login');
    } catch { /* Ignore malformed storage values; never install partial credentials. */ }
  };
  window.addEventListener('storage', listener);
  return () => window.removeEventListener('storage', listener);
}
